/* eslint-disable no-bitwise */
/* eslint-disable camelcase */
/* eslint-disable import/no-cycle */
import { takeLatest, select, put } from 'redux-saga/effects'
import moment from 'moment'
import { Types } from '../ducks/humanResources'
import api from '../../services/segi/index'
import powerAppsApi from '../../services/powerapps/index'
import { history } from '../index'
import { notifyError, notifySuccess } from '../../utils/notify'

function* getMonthBalance() {
  try {
    const userId = yield select(state => state.auth.user.id)

    const formData = new FormData()
    formData.append('id', userId)
    formData.append('acao', 'saldo_mes')

    const res = yield api.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    console.tron.log('saldo_mes', res.data)

    yield put({
      type: Types.GET_MONTH_BALANCE_SUCCEEDED,
      payload: res.data,
    })
  } catch (err) {
    console.tron.log('erro', err)
    yield put({
      type: Types.GET_MONTH_BALANCE_FAILED,
      payload: JSON.stringify(err),
    })
  }
}

function* getHoursBank(action) {
  try {
    const userId = (action.payload && (typeof action.payload === 'object' ? action.payload.userId : action.payload)) || (yield select(state => state.auth.user.id))

    const formData = new FormData()
    formData.append('id', userId)
    formData.append('acao', 'banco_acumulado')

    const res = yield api.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    console.tron.log('banco_acumulado', res.data)

    yield put({
      type: Types.GET_HOURS_BANK_SUCCEEDED,
      payload: res.data,
    })
  } catch (err) {
    console.tron.log(err)
    yield put({
      type: Types.GET_HOURS_BANK_FAILED,
    })
  }
}

function* getExpedientStatus() {
  try {
    const userId = yield select(state => state.auth.user.id)

    const formData = new FormData()
    formData.append('id', userId)
    formData.append('acao', 'exibe_iniciar_expediente')

    const res = yield api.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    console.tron.log('exibe_iniciar_expediente', res.data)

    yield put({
      type: Types.GET_EXPEDIENT_STATUS_SUCCEEDED,
      payload: res.data,
    })
  } catch (err) {
    console.tron.log(err)
    yield put({
      type: Types.GET_EXPEDIENT_STATUS_FAILED,
      payload: 'erro',
    })
  }
}

function* getLastExpedientInput() {
  try {
    const userId = yield select(state => state.auth.user.id)

    const formData = new FormData()
    formData.append('id', userId)
    formData.append('acao', 'ultima_entrada')

    const res = yield api.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    console.tron.log('ultima_entrada', res.data)

    yield put({
      type: Types.GET_LAST_EXPEDIENT_INPUT_SUCCEEDED,
      payload: res.data,
    })
  } catch (err) {
    console.tron.log(err)
    yield put({
      type: Types.GET_LAST_EXPEDIENT_INPUT_FAILED,
    })
  }
}

function* getLastExpedientOutput() {
  try {
    const userId = yield select(state => state.auth.user.id)

    const formData = new FormData()
    formData.append('id', userId)
    formData.append('acao', 'ultima_saida')

    const res = yield api.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    console.tron.log('ultima_saida', res.data)

    yield put({
      type: Types.GET_LAST_EXPEDIENT_OUTPUT_SUCCEEDED,
      payload: res.data,
    })
  } catch (err) {
    console.tron.log(err)
    yield put({
      type: Types.GET_LAST_EXPEDIENT_OUTPUT_FAILED,
    })
  }
}

function* getMonthlyWorkload(action) {
  try {
    const userId = (action.payload && (typeof action.payload === 'object' ? action.payload.userId : action.payload)) || (yield select(state => state.auth.user.id))

    const formData = new FormData()
    formData.append('id', userId)
    formData.append('acao', 'carga_realizada_mensal')

    const res = yield api.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    console.tron.log('carga_realizada_mensal', Object.values(res.data))

    yield put({
      type: Types.GET_MONTHLY_WORKLOAD_SUCCEEDED,
      payload: Object.values(res.data),
    })
  } catch (err) {
    console.tron.log(err)
    yield put({
      type: Types.GET_MONTHLY_WORKLOAD_FAILED,
    })
  }
}

function* getMonthlyActivities() {
  try {
    const userId = yield select(state => state.auth.user.id)

    const formData = new FormData()
    formData.append('id', userId)
    formData.append('acao', 'alocacao_carga_horaria')

    const res = yield api.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    console.tron.log('alocacao_carga_horaria', Object.values(res.data))

    yield put({
      type: Types.GET_MONTHLY_ACTIVITIES_SUCCEEDED,
      payload: Object.values(res.data),
    })
  } catch (err) {
    console.tron.log(err)
    yield put({
      type: Types.GET_MONTHLY_ACTIVITIES_FAILED,
    })
  }
}

function* getProjects() {
  try {
    const userId = yield select(state => state.auth.user.id)
    console.log('userId', userId)

    const formData = new FormData()
    formData.append('id', userId)
    formData.append('acao', 'lista_projetos')

    const res = yield api.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    const parsed = Object.values(res.data)
    const projects = parsed.map(project => ({
      value: project.id,
      label: project.nome,
      site: project.site,
      proj_id: project.proj_id,
    }))

    console.tron.log('lista_projetos', projects)

    yield put({
      type: Types.GET_PROJECTS_SUCCEEDED,
      payload: projects,
    })
  } catch (err) {
    console.tron.log(err)
    yield put({
      type: Types.GET_PROJECTS_FAILED,
    })
  }
}

function* getActivities(action) {
  try {
    const userId = yield select(state => state.auth.user.id)

    const formData = new FormData()
    formData.append('id', userId)
    formData.append('acao', 'lista_atividades')
    formData.append('projeto_id', `${action.payload.projectId}`)

    const res = yield api.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    const parsed = Object.values(res.data)
    const activities = parsed.map(activity => ({
      value: activity,
      label: activity,
    }))

    console.tron.log('lista_atividades', activities)

    yield put({
      type: Types.GET_ACTIVITIES_SUCCEEDED,
      payload: activities,
    })
  } catch (err) {
    console.tron.log(err)
    yield put({
      type: Types.GET_ACTIVITIES_FAILED,
    })
  }
}

function* startExpedient() {
  try {
    const userId = yield select(state => state.auth.user.id)

    const formData = new FormData()
    formData.append('id', userId)
    formData.append('acao', 'registra_entrada')

    const res = yield api.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    console.tron.log('registra_entrada', res.data)

    yield put({
      type: Types.START_EXPEDIENT_SUCCEEDED,
      payload: res.data,
    })
  } catch (err) {
    console.tron.log(err)
    yield put({
      type: Types.START_EXPEDIENT_FAILED,
    })
  }
}

function* finishExpedient(action) {
  try {
    const userId = yield select(state => state.auth.user.id)
    const { data } = action.payload

    const formData = new FormData()
    formData.append('id', userId)
    formData.append('acao', 'registra_saida')
    formData.append('Data', data.Data)
    formData.append('DataEntrada', data.DataEntrada)
    formData.append('DataSaida', data.DataSaida)
    formData.append('items', JSON.stringify(data.items))
    formData.append('retroativo', data.retroativo)
    formData.append('Justificativa', data.Justificativa)

    console.log('formData', formData)

    const res = yield api.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    console.log('registra_saida', res.data)

    history.push('/')

    if (data.retroativo) {
      notifySuccess('Expediente retroativo cadastrado com sucesso.')
    } else {
      notifySuccess('Expediente finalizado com sucesso.')
    }

    yield put({ type: Types.FINISH_EXPEDIENT_SUCCEEDED })
  } catch (err) {
    console.tron.log(err)
    yield put({
      type: Types.FINISH_EXPEDIENT_FAILED,
    })
  }
}

function* checkRetroactive(action) {
  try {
    const userId = yield select(state => state.auth.user.id)
    const { data } = action.payload

    const formData = new FormData()
    formData.append('id', userId)
    formData.append('acao', 'verifica_sobreposicao')
    formData.append('retroativo', 'true')
    formData.append('Data', data.Data)
    formData.append('HoraEntrada', data.HoraEntrada)
    formData.append('HoraSaida', data.HoraSaida)

    console.tron.log('verifica_sobreposicao formData', formData)

    const res = yield api.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    console.tron.log('verifica_sobreposicao', res.data)

    const ok = res.data.ok === true || res.data.ok === 1 || res.data.ok === 'true'
    yield put({
      type: Types.CHECK_RETROACTIVE_SUCCEEDED,
      payload: {
        ok,
        sobrepoe: !ok,
        codigo: res.data.codigo || null,
        msg: res.data.msg || '',
      },
    })
  } catch (err) {
    console.tron.log(err)
    yield put({
      type: Types.CHECK_RETROACTIVE_FAILED,
      payload: 'Erro.',
    })
  }
}

function* getMonthlyActivitiesReport(action) {
  try {
    let month;
    let userId;
    if (action.payload && typeof action.payload === 'object') {
      month = action.payload.month;
      userId = action.payload.userId;
    } else {
      month = action.payload;
    }
    const currentUserId = yield select(state => state.auth.user.id)
    const targetUserId = userId || currentUserId

    const formData = new FormData()
    formData.append('id', targetUserId)
    formData.append('acao', 'relatorio_atividades')
    formData.append('mes', month)

    const res = yield api.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    console.tron.log('relatorio_atividades', Object.values(res.data))

    yield put({
      type: Types.GET_MONTHLY_ACTIVITIES_REPORT_SUCCEEDED,
      payload: Object.values(res.data),
    })
  } catch (err) {
    console.tron.log(err)
    yield put({
      type: Types.GET_MONTHLY_ACTIVITIES_REPORT_FAILED,
    })
  }
}

function* registerAbsence(action) {
  try {
    const userId = yield select(state => state.auth.user.id)

    const {
      DataEntrada, DataSaida, HoraEntrada, HoraSaida, Justificativa, files,
    } = action.payload.data

    console.tron.log('action.payload', action.payload)

    // Verifica sobreposição de data
    const formData = new FormData()
    formData.append('id', userId)
    formData.append('acao', 'verifica_sobreposicao')
    formData.append('Data', DataEntrada)
    formData.append('DataSaida', DataSaida)
    formData.append('HoraEntrada', HoraEntrada)
    formData.append('HoraSaida', HoraSaida)

    console.tron.log('verifica_sobreposicao formData', formData)

    const res = yield api.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    console.tron.log('verifica_sobreposicao', res.data.sobrepoe)

    if (res.data.sobrepoe === true) {
      notifyError('Período já registrado.')

      yield put({
        type: Types.REGISTER_ABSENCE_FAILED,
      })
    } else {
      const formData = new FormData()
      formData.append('id', userId)
      formData.append('acao', 'registra_ausencia')
      formData.append('DataEntrada', `${DataEntrada} ${!HoraEntrada ? '00:00' : HoraEntrada}`)
      formData.append('DataSaida', `${DataSaida} ${!HoraSaida ? '23:59' : HoraSaida}`)
      /* formData.append('Motivo', Motivo) */
      formData.append('Justificativa', Justificativa)

      if (files && files.length > 0) {
        files.forEach((file, index) => {
          formData.append(`arquivo${index}`, new Blob([file], { type: file.type }), file.name || 'file')
        })
      }

      console.tron.log('registra_ausencia formData', formData)

      const res = yield api.post('/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      })

      console.tron.log('registra_ausencia res', res.data)

      history.push('/')

      notifySuccess('Justificativa cadastrada com sucesso.')

      yield put({
        type: Types.REGISTER_ABSENCE_SUCCEEDED,
      })
    }
  } catch (err) {
    console.tron.log(err)
    notifyError(toString(err))
    yield put({
      type: Types.REGISTER_ABSENCE_FAILED,
    })
  }
}

function* registerVacation(action) {
  try {
    const userId = yield select(state => state.auth.user.id)

    const { initialDate, finalDate } = action.payload.data

    const formData = new FormData()
    formData.append('id', userId)
    formData.append('acao', 'registra_ferias')
    formData.append('DataEntrada', moment(initialDate).format('YYYY-MM-DD'))
    formData.append('DataSaida', moment(finalDate).format('YYYY-MM-DD'))

    console.tron.log('registra_ferias formData', formData)

    const res = yield api.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    console.tron.log('registra_ferias res', res.data)

    history.push('/')

    notifySuccess('Registro de férias enviado com sucesso. Aguarde a aprovação da Gerência.')

    yield put({
      type: Types.REGISTER_VACATION_SUCCEEDED,
    })
  } catch (err) {
    console.tron.log(err)
    notifyError(toString(err))
    yield put({
      type: Types.REGISTER_VACATION_FAILED,
    })
  }
}

function* updateSolicitation(action) {
  try {
    const userEmail = yield select(state => state.auth.user.mail)
    const { type, solicitation, openSolicitations, nextSolicitation, simple } = action.payload
    const isVacation = solicitation?.pend_assunto === 'Férias'
    const approvedMsg = isVacation ? 'Registro de férias aprovado com sucesso.' : 'Solicitação aprovada com sucesso.'
    const rejectedMsg = isVacation ? 'Registro de férias recusado com sucesso.' : 'Solicitação recusada com sucesso.'
    const updatedMsg = isVacation ? 'Registro de férias atualizado com sucesso.' : 'Solicitação atualizada com sucesso.'

    const body = {
      acao: 'avaliar_pendencias',
      user_email: userEmail,
      pend_tab: solicitation.pend_tab,
      pend_id: solicitation.pend_id,
      pend_aprov: type,
      pend_justif: solicitation.reason,
    }

    console.tron.log('avaliar_pendencias body', body)

    const res = yield powerAppsApi.post('/', body, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    console.tron.log('avaliar_pendencias res', res.data)

    if (res.data && typeof res.data === 'object' && res.data.ok === false) {
      throw new Error(res.data.msg || 'Erro ao avaliar pendência.')
    }

    /* yield new Promise(resolve => setTimeout(resolve, 3000)) */
    if (!simple) {
      if (type === 1 && nextSolicitation) {
        history.push({
          pathname: `/gerencia/solicitacoes/${nextSolicitation.pend_id}`,
          state: {
            solicitation: nextSolicitation,
            openSolicitations,
          },
        })
        notifySuccess(approvedMsg)
      } else if (type === 1 && !nextSolicitation) {
        history.push('/gerencia/solicitacoes')
        notifySuccess(approvedMsg)
      } else if (type === 2 && nextSolicitation) {
        history.push({
          pathname: `/gerencia/solicitacoes/${nextSolicitation.pend_id}`,
          state: {
            solicitation: nextSolicitation,
            openSolicitations,
          },
        })
        notifySuccess(rejectedMsg)
      } else if (type === 2 && !nextSolicitation) {
        history.push('/gerencia/solicitacoes')
        notifySuccess(rejectedMsg)
      } else if (type === 0) {
        history.push('/colaborador/solicitacoes')
        notifySuccess(updatedMsg)
      }
    } else if (type === 1) {
      notifySuccess(approvedMsg)
    } else if (type === 2) {
      notifySuccess(rejectedMsg)
    } else if (type === 0) {
      notifySuccess(updatedMsg)
    }
    yield put({ type: Types.UPDATE_SOLICITATION_SUCCEEDED })
  } catch (err) {
    console.tron.log(err)
    notifyError(toString(err))
    yield put({
      type: Types.UPDATE_SOLICITATION_FAILED,
      payload: toString(err),
    })
  }
}

function* getPendingSolicitations(action) {
  try {
    const userEmail = yield select(state => state.auth.user.mail)
    const { isManager } = action.payload

    const body = {
      acao: 'listar_pendencias_a_avaliar',
      user_email: userEmail,
      gerente: isManager ? 1 : 0,
    }

    console.tron.log('getPendingSolicitations body', body)

    const res = yield powerAppsApi.post('/', body, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    let data = null

    if (res.data) {
      data = res.data.map(i => ({
        ...i,
        pend_id: Number(i.pend_id),
        files: i.pend_arquivo_caminho && i.pend_arquivo_id ? (
          (i.pend_arquivo_caminho.split(',')).map((path, index) => ({
            id: (i.pend_arquivo_id.split(','))[index],
            path,
            extension: path.slice((path.lastIndexOf('.') - 1 >>> 0) + 2).toLowerCase(),
          }))
        ) : null,
      }))
    }

    console.tron.log('listar_pendencias_a_avaliar res', data)

    yield put({ type: Types.GET_PENDING_SOLICITATIONS_SUCCEEDED, payload: data })
  } catch (err) {
    console.tron.log(err)
    notifyError(toString(err))
    yield put({
      type: Types.GET_PENDING_SOLICITATIONS_FAILED,
    })
  }
}

function* deletePendingSolicitation(action) {
  try {
    const { pend_id, pend_tab } = action.payload

    const body = {
      pend_id,
      pend_tab,
      acao: 'excluir_pendencia',
    }

    console.tron.log('excluir_pendencia body', body)

    const res = yield powerAppsApi.post('/', body, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    console.tron.log('excluir_pendencia res', res.data)

    history.push('/colaborador/solicitacoes')

    notifySuccess('Solicitação excluída com sucesso.')

    yield put({ type: Types.DELETE_PENDING_SOLICITATION_SUCCEEDED })
  } catch (err) {
    console.tron.log(err)
    notifyError(toString(err))
    yield put({
      type: Types.DELETE_PENDING_SOLICITATION_FAILED,
    })
  }
}

function* getRhDashboard(action) {
  try {
    const userId = yield select(state => state.auth.user.id)
    const mes = action.payload?.mes || moment().format('MM/YYYY')

    const formData = new FormData()
    formData.append('id', userId)
    formData.append('acao', 'dashboard_rh_colaboradores')
    formData.append('mes', mes)

    const res = yield api.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    console.tron.log('dashboard_rh_colaboradores', res.data)

    yield put({
      type: Types.GET_RH_DASHBOARD_SUCCEEDED,
      payload: res.data,
    })
  } catch (err) {
    console.tron.log(err)
    yield put({
      type: Types.GET_RH_DASHBOARD_FAILED,
      payload: JSON.stringify(err),
    })
  }
}

export const humanResourcesSagas = [
  takeLatest(Types.GET_MONTH_BALANCE_REQUESTED, getMonthBalance),
  takeLatest(Types.GET_HOURS_BANK_REQUESTED, getHoursBank),
  takeLatest(Types.GET_EXPEDIENT_STATUS_REQUESTED, getExpedientStatus),
  takeLatest(Types.GET_LAST_EXPEDIENT_INPUT_REQUESTED, getLastExpedientInput),
  takeLatest(Types.GET_LAST_EXPEDIENT_OUTPUT_REQUESTED, getLastExpedientOutput),
  takeLatest(Types.GET_MONTHLY_WORKLOAD_REQUESTED, getMonthlyWorkload),
  takeLatest(Types.GET_MONTHLY_ACTIVITIES_REQUESTED, getMonthlyActivities),
  takeLatest(Types.GET_PROJECTS_REQUESTED, getProjects),
  takeLatest(Types.GET_ACTIVITIES_REQUESTED, getActivities),
  takeLatest(Types.START_EXPEDIENT_REQUESTED, startExpedient),
  takeLatest(Types.FINISH_EXPEDIENT_REQUESTED, finishExpedient),
  takeLatest(Types.CHECK_RETROACTIVE_REQUESTED, checkRetroactive),
  takeLatest(Types.GET_MONTHLY_ACTIVITIES_REPORT_REQUESTED, getMonthlyActivitiesReport),
  takeLatest(Types.REGISTER_ABSENCE_REQUESTED, registerAbsence),
  takeLatest(Types.REGISTER_VACATION_REQUESTED, registerVacation),
  takeLatest(Types.UPDATE_SOLICITATION_REQUESTED, updateSolicitation),
  takeLatest(Types.GET_PENDING_SOLICITATIONS_REQUESTED, getPendingSolicitations),
  takeLatest(Types.DELETE_PENDING_SOLICITATION_REQUESTED, deletePendingSolicitation),
  takeLatest(Types.GET_RH_DASHBOARD_REQUESTED, getRhDashboard),
]
